import { fetchPropertyImages, type PropertyImage } from '@/core/services/contentfulClient';
import { logger } from '@/core/logger';
import { ImageSourcePropType } from 'react-native';

/**
 * Convert PropertyImage array to ImageSourcePropType array for React Native
 */
function convertToImageSources(images: PropertyImage[]): ImageSourcePropType[] {
  return images.map((img) => ({ uri: img.url }));
}

/**
 * Fetch property images for multiple projects
 * Returns a map of project name to image sources
 */
export async function fetchPropertyImagesForProjects(
  projectNames: string[]
): Promise<Record<string, ImageSourcePropType[]>> {
  const result: Record<string, ImageSourcePropType[]> = {};

  // Fetch images for all projects in parallel
  const fetchPromises = projectNames.map(async (projectName) => {
    try {
      const images = await fetchPropertyImages(projectName);
      result[projectName] = convertToImageSources(images);
    } catch (error) {
      logger.error('usePropertyImages', 'Failed to fetch images for project', {
        projectName,
        error,
      });
      result[projectName] = [];
    }
  });

  await Promise.all(fetchPromises);

  return result;
}

